import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { SlideFrame } from '../SlideFrame';
import { proofPoints } from '../../data/deckContent';
export function ProofSlide() {
  const reduced = useReducedMotion();
  return <SlideFrame eyebrow="Two proof points" index={5} data-id="element-163" data-mp="1311jxr5vgo9u">
      <div data-id="element-164" data-mp="y41cpcxadfh5">
        <h2 className="text-[clamp(24px,3.4vw,60px)] font-semibold leading-[1.06] tracking-tight text-white" data-id="element-165" data-mp="y4b1wyaibils">
          Same contract.{' '}
          <span className="text-[color:var(--sv-green)]" data-id="element-166" data-mp="u393gjoezakv">
            Different reward.
          </span>
        </h2>

        <div className="mt-[3vh] grid grid-cols-2 items-stretch gap-[2vw]" data-id="element-167" data-mp="p9d71lnstvrt">
          {proofPoints.map((point, i) => <motion.article key={point.product} initial={reduced ? false : {
          opacity: 0,
          y: 14
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.4,
          delay: 0.08 * i,
          ease: 'easeOut'
        }} className="flex flex-col rounded-[1.6vw] border border-white/10 bg-white/[0.04] p-[2vw]" data-id="element-168" data-mp="fda3qch7nr3a" data-mpi={i}>
              <p className="text-[clamp(10px,0.95vw,18px)] uppercase tracking-[0.28em] text-[color:var(--sv-green)]" data-id="element-169" data-mp="33yumbhqgpzj2">
                {point.product}
              </p>

              <p className="mt-[1.8vh] text-[clamp(11px,1.05vw,20px)] font-light text-white/50" data-id="element-170" data-mp="2u42p4f0sleot">
                {point.invested}
              </p>

              <p className={point.statementScale === 'xl' ? 'mt-[0.6vh] text-[clamp(30px,4vw,72px)] font-semibold leading-[0.98] tracking-tight text-white' : 'mt-[0.6vh] text-[clamp(17px,2.15vw,40px)] font-semibold leading-[1.08] tracking-tight text-white'} data-id="element-171" data-mp="3mrf689o6ouaq">
                {point.statement}
              </p>

              <p className="mt-[1.6vh] text-[clamp(9px,0.85vw,16px)] uppercase tracking-[0.3em] text-white/80" data-id="element-172" data-mp="22b242k9svovg">
                {point.reward}
              </p>

              <p className="mt-auto pt-[2vh] text-[clamp(11px,1.1vw,21px)] font-light leading-snug text-white/60" data-id="element-173" data-mp="26au76hgfd2tf">
                {point.support}
              </p>

              {point.bonus ? <p className="mt-[1.2vh] border-t border-white/10 pt-[1.2vh] text-[clamp(10px,0.95vw,18px)] font-light text-[color:var(--sv-green)]" data-id="element-174" data-mp="7xpn77fyrofk">
                  {point.bonus}
                </p> : null}
            </motion.article>)}
        </div>

        <p className="mt-[3vh] text-[clamp(12px,1.35vw,26px)] font-light text-white/70" data-id="element-175" data-mp="3qantdw3cndi6">
          Different product. Different value.{' '}
          <span className="font-medium text-[color:var(--sv-green)]" data-id="element-176" data-mp="3gawwxov8aofg">
            Same Solventum promise.
          </span>
        </p>
      </div>
    </SlideFrame>;
}